import { AlertCircle, Check } from "lucide-react";

interface ToolCallIndicatorProps {
  tool: string;
  summary: string;
}

/** Subtle status pill shown below assistant messages. */
const ToolCallIndicator = ({ tool, summary }: ToolCallIndicatorProps) => {
  const label = summary || tool;

  // Error indicators from the humanized backend — or legacy raw errors
  const isError =
    label.startsWith("Error:") ||
    label.startsWith("Invalid input:") ||
    label.includes("snag") ||
    label.includes("Couldn't find") ||
    label.includes("permissions") ||
    label.includes("Took too long") ||
    label.includes("No results found");
  label.includes("Too many requests");

  return (
    <div className="flex items-center gap-1.5 rounded px-2 py-0.5">
      {isError ? (
        <AlertCircle className="h-3 w-3 text-amber-400 shrink-0" />
      ) : (
        <Check className="h-3 w-3 text-primary/40 shrink-0" />
      )}
      <span className="text-xs text-gray-400">{label}</span>
    </div>
  );
};

export default ToolCallIndicator;
